import { supabase } from '../lib/supabase';

// PostgREST builders are lazy thenables. Awaiting the insert is essential:
// merely constructing it (even with `void`) never sends an HTTP request.
export async function saveOrderEnquiry(payload) {
  if (!supabase) return { saved: false, unavailable: true };
  try {
    const { error } = await supabase.from('orders').insert(payload);
    return { saved: !error, error: error || null };
  } catch (error) {
    return { saved: false, error };
  }
}
